import axios from 'axios';

export default {
  getI18n(id, locale) {
    return axios.get(`/static/i18n/${id}/${locale}.json`)
      .then(response => response.data);
  },
};



// WEBPACK FOOTER //
// ./src/api/i18n.js